import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';
import useService from '../../utils/useService';
import { hydrateFormData, dehydrateFormData } from '../../utils/formDataParser';
import { ICustomResponse, IGSTConfig, ISegmentConfigData } from '../../utils/type';

const useClone = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history: any = useHistory();
	const location = useLocation();
	const { requestCreateConfig } = useService();

	const CloneConfig = (gstConfig: IGSTConfig) => {
		setShowLoader(true);
		requestCreateConfig(app.appName, { ...gstConfig }).then(
			(res: ICustomResponse) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(`Error: ${res?.data?.error || 'Error occured while cloning the GST config'}`, { type: 'error' });
					setShowLoader(false);
				} else {
					showAlert('Config Created');
					history.goBack();
				}
			},
			(err: any) => {
				showAlert(`Error: ${err?.response?.data?.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: ISegmentConfigData) => {
		CloneConfig(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};
	return {
		data: {
			...hydrateFormData(_get(location, ['state', 'rowData'], EMPTY_OBJECT))
		},
		gstOfferSegmentsData: history?.location?.state?.gstOfferSegmentsData,
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useClone;
